module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "bulk-client-add"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v(_vm._s('Bulk processing of products'))]), _vm._v(" "), [_c('el-table', {
    staticClass: "products",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.products
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "number",
      "label": _vm.$t('static.products.table.number'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": _vm.$t('static.products.table.name'),
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small dark",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.proceed')))])], 1)]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa48403","hasScoped":false}!./src/app/components/bulkProcessProductModal/bulkProcessProductModal.html
// module id = 3032
// module chunks = 1